import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { getAPILoggedInUser } from '../../../api/GET/loggedInUser'

export const useQueryUser = () => {
  const navigate = useNavigate()

  return useQuery({
    queryKey: 'loggedInUser',
    queryFn: () => getAPILoggedInUser(),
    staleTime: 0,
    onError: () => navigate('/login'),
  })
}
